import Flux from 'lib/flux';
import NavigationConstants from 'constants/navigation';

const NavigationActionCreator = Flux.createActionCreator({
  transitionTo(Screen, props) {
    this.dispatchAction(NavigationConstants.TRANSITION_TO, Screen, props || {});
  },

  transitionBack() {
    this.dispatchAction(NavigationConstants.TRANSITION_BACK);
  },
});

export default NavigationActionCreator;
